import { createParser } from "../create-parser";
var config = {
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  },
  shadow: {
    property: "boxShadow",
    scale: "shadows",
    deprecated: true,
    replacement: "boxShadow"
  }
};
/**
 * Types for box and text shadow properties
 */

export var shadow = createParser(config);